var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "d-flex align-items-center mb-2",
          staticStyle: { gap: "8px" },
        },
        [
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.status,
                  expression: "status",
                },
              ],
              staticClass: "form-control",
              staticStyle: { "max-width": "200px" },
              on: {
                change: [
                  function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.status = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                  _vm.onFilterChange,
                ],
              },
            },
            [
              _c("option", { attrs: { value: "imported" } }, [
                _vm._v("\n        Imported\n      "),
              ]),
              _vm._v(" "),
              _c("option", { attrs: { value: "not_imported" } }, [
                _vm._v("\n        Not Imported\n      "),
              ]),
              _vm._v(" "),
              _c("option", { attrs: { value: "all" } }, [
                _vm._v("\n        All\n      "),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.processed,
                  expression: "processed",
                },
              ],
              staticClass: "form-control",
              staticStyle: { "max-width": "200px" },
              on: {
                change: [
                  function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.processed = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                  _vm.onFilterChange,
                ],
              },
            },
            [
              _c("option", { attrs: { value: "all" } }, [
                _vm._v("\n        All\n      "),
              ]),
              _vm._v(" "),
              _c("option", { attrs: { value: "original" } }, [
                _vm._v("\n        Original\n      "),
              ]),
              _vm._v(" "),
              _c("option", { attrs: { value: "filtered" } }, [
                _vm._v("\n        Filtered\n      "),
              ]),
              _vm._v(" "),
              _c("option", { attrs: { value: "pre_processed" } }, [
                _vm._v("\n        Pre-processed\n      "),
              ]),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c("table", { staticClass: "table" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_vm.histories, function (history) {
            return _c(
              "tr",
              { key: _vm.rowKey(history), staticClass: "history-row" },
              [
                _c("td", [_vm._v(_vm._s(_vm.formatDate(history.created_at)))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.formatTime(history.time)))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(history.type || "—"))]),
                _vm._v(" "),
                _c("td", [
                  _c(
                    "span",
                    {
                      staticClass: "badge",
                      class:
                        history.source === "not_imported"
                          ? "badge-danger"
                          : "badge-success",
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            history.source === "not_imported"
                              ? "Not Imported"
                              : "Imported"
                          ) +
                          "\n          "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("td", [
                  history.layout
                    ? _c(
                        "a",
                        {
                          attrs: {
                            href: `/banner/${history.layout.customer_id}/group/${history.layout_id}/show`,
                            target: "_blank",
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(history.layout_id) +
                              "\n          "
                          ),
                        ]
                      )
                    : _c("span", [
                        _vm._v(_vm._s(history.layout_id) + " (deleted)"),
                      ]),
                ]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(history?.mapping?.name || "N/A"))]),
                _vm._v(" "),
                _c("td", [
                  _c("div", { staticClass: "dropdown" }, [
                    _c(
                      "a",
                      {
                        staticClass: "action",
                        attrs: {
                          href: "#",
                          role: "button",
                          "data-toggle": "dropdown",
                        },
                      },
                      [
                        _c("b-icon", {
                          staticClass: "text-body font-2xl",
                          attrs: { icon: "three-dots-vertical" },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "dropdown-menu" },
                      [
                        history.source === "not_imported"
                          ? [
                              _c(
                                "button",
                                {
                                  staticClass: "dropdown-item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.viewError(history)
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "bi bi-exclamation-triangle",
                                  }),
                                  _vm._v(" View error\n                "),
                                ]
                              ),
                            ]
                          : [
                              _c(
                                "button",
                                {
                                  staticClass: "dropdown-item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.downloadFile(history.file_path)
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "bi bi-cloud-arrow-down",
                                  }),
                                  _vm._v(" Download\n                "),
                                ]
                              ),
                              _vm._v(" "),
                              !_vm.disableRerun
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "dropdown-item",
                                      on: {
                                        click: function ($event) {
                                          return _vm.rerun(history)
                                        },
                                      },
                                    },
                                    [
                                      _c("i", { staticClass: "bi bi-repeat" }),
                                      _vm._v(" Rerun\n                "),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.qaTestsUrl && history.mapping?.id
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      attrs: {
                                        href: `${_vm.qaTestsUrl}?import_history=${history.source_id}`,
                                        target: "_blank",
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "bi bi-clipboard-check",
                                      }),
                                      _vm._v(
                                        " Create QA test\n                "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                      ],
                      2
                    ),
                  ]),
                ]),
              ]
            )
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _c("b-pagination", {
        attrs: {
          "total-rows": _vm.pagination.total,
          "per-page": 5,
          align: "center",
          "first-number": "",
          "last-number": "",
        },
        on: { input: _vm.fetchHistories },
        model: {
          value: _vm.currentPage,
          callback: function ($$v) {
            _vm.currentPage = $$v
          },
          expression: "currentPage",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", { attrs: { scope: "col" } }, [
          _vm._v("\n          Date\n        "),
        ]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [
          _vm._v("\n          Time\n        "),
        ]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [
          _vm._v("\n          Type\n        "),
        ]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [
          _vm._v("\n          Status\n        "),
        ]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [
          _vm._v("\n          Layout\n        "),
        ]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [
          _vm._v("\n          Settings\n        "),
        ]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [
          _vm._v("\n          Actions\n        "),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }